import { Link } from 'react-router-dom';
import { ScrollRevealWrapper } from '../../../components/feature/ScrollRevealWrapper';

const recursos = [
  {
    icon: 'ri-quill-pen-line',
    titulo: 'Declare seu futuro',
    descricao: 'Escreva uma carta para o seu eu de 3 anos a partir de hoje. Neurociência comprova: visualização escrita ativa as mesmas redes neurais que a experiência real.',
  },
  {
    icon: 'ri-mail-send-line',
    titulo: 'Receba no momento certo',
    descricao: 'A carta fica guardada e você a recebe na data que escolher — como uma mensagem de si mesma do passado, provando que você chegou aonde queria.',
  },
  {
    icon: 'ri-brain-line',
    titulo: 'Reprogramação profunda',
    descricao: 'O ato de escrever no tempo presente ("estou", "tenho", "sou") programa o sistema reticular ativador para identificar oportunidades alinhadas.',
  },
];

const ciencia = [
  {
    stat: '5x',
    desc: 'Mais áreas cerebrais ativadas ao escrever vs. apenas pensar',
  },
  {
    stat: '42%',
    desc: 'De aumento na probabilidade de atingir objetivos quando escritos',
  },
  {
    stat: '21 dias',
    desc: 'Para consolidar novas crenças com prática de escrita consistente',
  },
];

export default function EscritaCarta() {
  return (
    <section className="py-28 bg-[#060606] relative overflow-hidden">
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold-500/20 to-transparent"></div>
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_60%,rgba(201,164,64,0.06),transparent_50%)]"></div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="grid lg:grid-cols-2 gap-20 items-center">
          {/* Lado esquerdo — imagem + carta */}
          <ScrollRevealWrapper animation="fade-right">
            <div className="relative">
              <div className="relative rounded-2xl overflow-hidden aspect-[4/3] border border-gold-500/15">
                <img
                  src="https://public.readdy.ai/ai/img_res/962a197e4d53167c252302187936bc8e.jpg"
                  alt="Escreva sua carta para o futuro"
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#060606]/50 to-transparent"></div>
              </div>

              {/* Quote flutuante */}
              <div className="absolute -bottom-6 -right-6 bg-[#0a0a0a] border border-gold-500/20 rounded-xl p-5 max-w-xs">
                <p className="text-white/65 text-xs italic font-['Montserrat'] leading-relaxed mb-2">
                  "Escrever para o eu futuro mudou minha perspectiva sobre o que é possível. Li a carta 2 anos depois — e havia realizado tudo."
                </p>
                <p className="text-gold-400 text-xs font-semibold font-['Montserrat']">— Fernanda L., CEO</p>
              </div>
            </div>
          </ScrollRevealWrapper>

          {/* Lado direito — copy */}
          <ScrollRevealWrapper animation="fade-left">
            <div>
              <div className="inline-flex items-center gap-3 mb-6">
                <div className="h-px w-6 bg-gold-500/50"></div>
                <span className="text-gold-400 text-xs font-semibold tracking-[0.25em] uppercase font-['Montserrat']">
                  Carta do Eu Futuro
                </span>
              </div>

              <h2 className="font-display text-5xl font-bold text-white leading-tight mb-5">
                Escreva para quem<br />
                <span className="text-gold-400">você vai se tornar.</span>
              </h2>

              <p className="text-white/55 leading-relaxed font-['Montserrat'] text-sm mb-10 font-light">
                Uma das ferramentas mais poderosas de reprogramação mental é a escrita projetiva — escrever no tempo presente para o seu eu futuro ativa os mesmos circuitos neurais que tornam objetivos reais.
              </p>

              {/* Recursos */}
              <div className="space-y-6 mb-10">
                {recursos.map((r, i) => (
                  <div key={i} className="flex items-start gap-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-gold-500/10 border border-gold-500/15 flex-shrink-0 mt-0.5">
                      <i className={`${r.icon} text-gold-400 text-base`}></i>
                    </div>
                    <div>
                      <h3 className="font-display text-base font-bold text-white mb-1">{r.titulo}</h3>
                      <p className="text-white/45 text-sm font-['Montserrat'] leading-relaxed">{r.descricao}</p>
                    </div>
                  </div>
                ))}
              </div>

              {/* Ciência */}
              <div className="grid grid-cols-3 gap-4 mb-10">
                {ciencia.map((c, i) => (
                  <div key={i} className="bg-[#111111] border border-gold-500/10 rounded-xl p-4 text-center">
                    <div className="font-display text-2xl font-bold text-gold-400 mb-1">{c.stat}</div>
                    <p className="text-white/35 text-xs font-['Montserrat'] leading-tight">{c.desc}</p>
                  </div>
                ))}
              </div>

              <Link
                to="/escrever-carta"
                className="inline-flex items-center gap-3 px-8 py-4 bg-gradient-to-r from-gold-500 to-gold-700 text-[#0a0a0a] rounded-full font-bold hover:from-gold-600 hover:to-gold-800 transition-all whitespace-nowrap font-['Montserrat'] text-sm tracking-wide"
              >
                <i className="ri-quill-pen-line"></i>
                Escrever Minha Carta
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </ScrollRevealWrapper>
        </div>
      </div>
    </section>
  );
}
